module.exports = __webpack_public_path__ + "static/media/c1x4_temp.04574cc8.jpg";